export const PURCHASED_ITEMS_KEY = 'purchased-items';

export const setSesstionStoragePurchasedItems = (key: string, value: string) => {
  sessionStorage.setItem(`${key}?${PURCHASED_ITEMS_KEY}`, value);
};

export const getSessionStoragePurchasedItems = (key: string) => {
  if (!sessionStorage) {
    return;
  }
  return sessionStorage.getItem(`${key}?${PURCHASED_ITEMS_KEY}`)!;
};

export const removeSessionStoragePurchasedItems = (key: string) => {
  sessionStorage.removeItem(`${key}?${PURCHASED_ITEMS_KEY}`);
};
